<template>
    <div v-if="sort === sel" class="inline-block">
        <vue-feather v-if="sortDir=='asc'" type="arrow-up" size="12px" />
        <vue-feather v-if="sortDir=='desc'" type="arrow-down" size="12px" />
    </div>
    <div v-else class="inline-block px-1">
        &nbsp;
    </div>
</template>

<script>

export default {
    props: ['sel', 'sortDir', 'sort']
}
</script>

<style>

</style>